import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer-wrapper">
      <footer className="footer">
        <p>© 2024 Thuỷ Hoàng. All Rights Reserved.</p>
      </footer>
    </div>
  );
};

export default Footer;
